{
    "name": "Red Curly Kale",
    "binomial_name": "",
    "common_names": [
        "redbor",
        "curly red kale"
    ],
    "description": "",
    "sun_requirements": "",
    "sowing_method": "",
    "spread": 0,
    "row_spacing": 0,
    "height": 0,
    "growing_degree_days": 0,
    "companions": [],
    "image": "/crops/images/red-curly-kale.jpg",
    "icon": "/crops/icons/red-curly-kale.avif"
}